import(/* webpackMode: "eager" */ "/var/www/light_of_empire_front/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/light_of_empire_front/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/light_of_empire_front/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager" */ "/var/www/light_of_empire_front/shared/ui/HudCorners/HudCorners.module.scss");
;
import(/* webpackMode: "eager" */ "/var/www/light_of_empire_front/widgets/Hub/components/HubCard/HubCard.module.scss");
;
import(/* webpackMode: "eager" */ "/var/www/light_of_empire_front/widgets/Hub/Hub.module.scss");
;
import(/* webpackMode: "eager" */ "/var/www/light_of_empire_front/widgets/Hub/components/HubCardSkeleton/HubCardSkeleton.module.scss");
